import React from 'react';
import { Tooltip } from '@material-ui/core';
import { GetApp } from '@material-ui/icons';

const DownloadIcon = ({ onClick, value, tooltip, disabled, color, colorName = '', className = '' }) => {
	return (
		<Tooltip
			title={
				tooltip !== '' && tooltip !== undefined ? tooltip : 'Descargar Archivo'
			}
		>
			<div onClick={onClick} className={className}>
				<label htmlFor="file-input" style={{ color: colorName }}>
					<GetApp />
				</label>
			</div>
		</Tooltip>
	);
};

export default DownloadIcon;
